const $$splitComponentImporter = () => import('/app/apps/web/src/routes/ny-bruker/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
export const Route = createFileRoute("/ny-bruker/")({
  validateSearch: z.object({
    status: z.enum(["ok", "feil"]).optional(),
    error: z.string().optional() // Added by the API login handler
  }),
  head: () => ({
    meta: [{
      title: "Ny bruker | Alice & Bob"
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});